/* ============================================================
   HIT: a gaveta da sacola (Tarefa 21; a B em direcao-b/index.html: conteudoSacola, itemHtml, atualizaG e as ações qtd e rm).

     window.HitSacola = { aplicar(secoes, foco), atualizar(foco), sincroniza(secoes, marca), marca(), prazo(ms) }

   O QUE FAZ
   - Registra a gaveta "sacola" na HitGaveta (hit-gaveta.js, que carrega antes): os links .abre-sacola (cabeçalho e barra de baixo,
     data-gaveta="sacola") passam a abrir a gaveta no lugar de ir a /cart. Sem este arquivo, sem a seção ou na própria página /cart, o link
     segue o caminho normal (/cart) e a compra continua possível.
   - O conteúdo vem do servidor: a seção sections/cart-drawer é um <template id="sacola-modelo"> (título, corpo e pé), desenhado pelo Liquid
     com a sacola de agora. montar() copia dele para a gaveta; o JS não desenha item nenhum.
   - Mudar a quantidade ("−", "+", "Remover"): POST /cart/change.js com a chave da linha e `sections: cart-drawer`; a resposta traz a seção já
     desenhada com a sacola nova, o <template> é trocado e a gaveta aberta se redesenha NO LUGAR (sem animar de novo, com a rolagem de antes e
     o foco no mesmo controle). Os cliques seguem uma fila: três "+" rápidos viram três pedidos, cada um a partir da quantidade que o anterior deixou.
   - O "+" no limite do estoque (aria-disabled, desenhado pelo Liquid com o estoque da variante) não pede nada à loja: mostra o aviso da B
     ("Quantidade máxima disponível", #toast). Se a loja recusar um "+" (422), o mesmo aviso e a gaveta se acerta com a sacola de verdade.
   - Depois de mudar, atualiza o número e o nome acessível dos links da sacola (.abre-sacola): o template leva data-n e data-rotulo.
   - Quem muda a sacola por fora (o Adicionar do produto, assets/hit-sacola-produto.js) pega HitSacola.marca() ANTES do pedido e entrega a
     resposta a HitSacola.sincroniza(secoes, marca): ela entra na MESMA fila dos cliques. Se a gaveta tinha uma mudança no ar, ou se mudou algo
     desde a marca (o add.js demorou e dois "−" já terminaram), as seções de fora são mais velhas que a sacola e a gaveta relê em vez de aplicá-las
     (uma resposta velha nunca sobrescreve a nova). Se nem a releitura vem, avisa e marca a gaveta como desatualizada.
   - Toda leitura e todo pedido à loja tem prazo (PRAZO): um GET pendurado não trava a fila nem o botão Adicionar; passar do prazo é falha.
     O prazo vem de HitSacola.prazo(ms) = { signal, limpa }, que o hit-sacola-produto.js também usa: AbortSignal.timeout onde existe e, sem ele
     (Safari antes do 16, iOS 15), um AbortController com setTimeout, desarmado por limpa() no finally de quem pediu.
   - Se a gaveta perde o fio da sacola (a mudança passou e a releitura falhou, ou a linha clicada não existe mais), mostra o aviso de erro e
     trava as próximas ações até reler: nenhum pedido sai de uma quantidade velha. O "−" nunca é travado pelo estoque (só o aumento é).

   CONTRATO COM O CHECKOUT. A gaveta só tem o link "Finalizar" para /cart. Este arquivo nunca envia o campo name=checkout nem chama /checkout: o
   checkout é o nativo da Shopify, alcançado pelo botão name=checkout do /cart (sections/main-cart.liquid; DESIGN §5).
   ============================================================ */
(function () {
  'use strict';

  if (window.HitSacola) return;
  const G = window.HitGaveta;
  const aviso = (msg, e) => console.warn(`hit-sacola.js: ${msg}`, e || '');
  if (!G) { aviso('a HitGaveta não carregou; os links da sacola seguem para /cart'); return; }

  const RAIZ = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const SECAO = 'cart-drawer';
  const MODELO = 'sacola-modelo';
  const PRAZO = 15000;       // ms: o /cart/change.js ou a releitura sem resposta nesse tempo é cortado
  const AVISO_MS = 3600;     // a duração do #toast na B
  const NA_PAGINA_CART = document.body.getAttribute('data-vista') === 'cart';

  /* o prazo de um fetch: { signal, limpa }. Quem pede lê o corpo e chama limpa() no finally (com o AbortController, desarma o setTimeout) */
  function prazo(ms) {
    if (typeof AbortSignal !== 'undefined' && typeof AbortSignal.timeout === 'function') return { signal: AbortSignal.timeout(ms), limpa() {} };
    if (typeof AbortController !== 'function') return { signal: undefined, limpa() {} };
    const c = new AbortController(), t = setTimeout(() => c.abort(), ms);
    return { signal: c.signal, limpa() { clearTimeout(t); } };
  }

  const $ = (s, r) => (r || document).querySelector(s);
  const modelo = () => document.getElementById(MODELO);
  const gaveta = () => document.getElementById('gaveta');
  const gavetaDaSacola = () => { const g = gaveta(); return g && g.getAttribute('data-gaveta-aberta') === 'sacola' ? g : null; };

  /* ---------- o modelo (a seção) ---------- */
  function parte(m, nome) {
    const f = document.createDocumentFragment();
    const origem = m.content.querySelector(`[data-parte="${nome}"]`);
    if (origem) origem.childNodes.forEach((n) => f.appendChild(n.cloneNode(true)));
    return f;
  }
  function montar() {
    const m = modelo();
    return m ? { titulo: m.dataset.titulo || '', corpo: parte(m, 'corpo'), pe: parte(m, 'pe') } : null;
  }
  const linhas = (m) => Array.from(m.content.querySelectorAll('.item'));

  /* ---------- aviso (#toast, a B) e região viva ---------- */
  let relogio = 0;
  function toast(msg) {
    const t = document.getElementById('toast');
    if (!t || !msg) return;
    t.textContent = msg;
    t.hidden = false;
    clearTimeout(relogio);
    relogio = setTimeout(() => { t.hidden = true; }, AVISO_MS);
  }
  // o redesenho troca os nós, e o leitor de tela só lê o que muda num nó que continua: a frase vai numa região viva própria, dentro da gaveta
  function anuncia(texto) {
    const g = gaveta();
    if (!g || !texto) return;
    let r = $('#sacola-anuncio', g);
    if (!r) {
      r = document.createElement('div');
      r.id = 'sacola-anuncio';
      r.className = 'sr';
      r.setAttribute('role', 'status');
      r.setAttribute('aria-live', 'polite');
      g.appendChild(r);
    }
    r.textContent = '';
    r.textContent = texto;
  }

  /* ---------- o número e o nome acessível dos links da sacola ---------- */
  function poeRotulo(m) {
    const n = Number(m.dataset.n), rotulo = m.dataset.rotulo;
    if (!Number.isInteger(n) || n < 0 || !rotulo) return;
    document.querySelectorAll('.abre-sacola').forEach((a) => a.setAttribute('aria-label', rotulo));
    document.querySelectorAll('.abre-sacola .ns').forEach((s) => { s.textContent = String(n); s.hidden = n === 0; });
  }

  /* ---------- redesenho da gaveta aberta, no lugar ---------- */
  function refoca(g, foco) {
    if (g.contains(document.activeElement)) return;
    let alvo = null;
    if (foco && foco.chave) {
      alvo = Array.from(g.querySelectorAll('[data-acao]')).find((b) => b.dataset.chave === foco.chave && b.dataset.acao === foco.acao);
    }
    alvo = alvo || $('.g-corpo [data-acao], .g-corpo a[href]', g) || $('.fechar', g);
    if (alvo) alvo.focus({ preventScroll: true });
  }
  function redesenha(foco) {
    const g = gavetaDaSacola(), c = g && montar();
    if (!c) return;
    const corpo = $('.g-corpo', g), pe = $('.g-pe', g), topo = corpo.scrollTop;
    $('#g-t', g).textContent = c.titulo;
    corpo.replaceChildren(c.corpo);
    corpo.scrollTop = topo;
    pe.replaceChildren(c.pe);
    pe.hidden = !pe.hasChildNodes();
    refoca(g, foco);
  }

  /* ---------- trocar o modelo pela seção que chegou ---------- */
  function aplicarModelo(html) {
    if (typeof html !== 'string' || !html) return false;
    const novo = new DOMParser().parseFromString(html, 'text/html').getElementById(MODELO);
    if (!novo) return false;
    const copia = document.importNode(novo, true), atual = modelo();
    if (atual) atual.replaceWith(copia); else document.body.appendChild(copia);
    poeRotulo(copia);
    return true;
  }
  /* secoes: o objeto `sections` de uma resposta do /cart/add.js, do /cart/change.js ou do GET ?sections=. true se a seção da gaveta veio e foi aplicada */
  function aplicar(secoes, foco) {
    if (!secoes || typeof secoes !== 'object' || !aplicarModelo(secoes[SECAO])) return false;
    redesenha(foco);
    return true;
  }
  async function atualizar(foco) {
    const p = prazo(PRAZO);
    try {
      const r = await fetch(`${RAIZ}?sections=${SECAO}`, { cache: 'no-store', headers: { Accept: 'application/json' }, signal: p.signal });
      return r.ok ? aplicar(await r.json(), foco) : false;
    } catch (e) {
      aviso('não consegui reler a sacola', e);
      return false;
    } finally { p.limpa(); }
  }

  /* ---------- mudar a quantidade ---------- */
  let pendentes = 0;
  let fila = Promise.resolve();
  // a gaveta não sabe como a sacola está (a mudança passou e a releitura falhou): nada sai antes de reler, para nunca partir de uma quantidade velha
  let dessincronizada = false;
  // quantas vezes a fila dos cliques andou (um passo ao entrar e outro ao sair de cada clique): quem muda a sacola por fora guarda o número ao começar
  // (marca) e, na volta, vê se a gaveta mexeu nesse meio-tempo
  let versao = 0;
  const marca = () => versao;
  const saiu = new Set(); // as linhas que a própria rajada de cliques tirou: o clique seguinte nelas é esperado, não é erro
  function ocupado(sim) {
    pendentes += sim ? 1 : -1;
    const g = gaveta();
    if (g) g.toggleAttribute('data-ocupado', pendentes > 0);
  }
  const frase = (nome) => { const m = modelo(); return m ? m.dataset[nome] : ''; };
  async function pede(chave, quantidade, signal) {
    const r = await fetch(`${RAIZ}cart/change.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: chave, quantity: quantidade, sections: SECAO }),
      signal,
    });
    return r;
  }
  /* releitura que acerta a gaveta com a sacola de verdade; sem ela, a gaveta fica marcada como desatualizada */
  async function acerta(foco) {
    dessincronizada = !(await atualizar(foco));
    return !dessincronizada;
  }
  async function muda(chave, acao) {
    const foco = { chave, acao };
    let reliu = false;
    if (dessincronizada) {
      reliu = true;
      if (!await acerta(foco)) { toast(frase('erro')); return; }
    }
    const m = modelo();
    const linha = m && linhas(m).find((l) => l.dataset.chave === chave);
    if (!linha) {
      if (saiu.has(chave)) return; // o clique anterior da fila a tirou
      aviso('a linha não está mais na sacola', chave);
      toast(frase('erro'));
      if (!reliu) await acerta(foco);
      return;
    }
    const atual = Number(linha.dataset.qtd), max = Number(linha.dataset.max);
    const nova = acao === 'remover' ? 0 : atual + (acao === 'mais' ? 1 : -1);
    if (acao === 'mais' && nova > max) { toast(m.dataset.maximo); return; } // o teto trava só o aumento: com mais que o estoque, o "−" age
    const p = prazo(PRAZO);
    try {
      const r = await pede(chave, nova, p.signal);
      if (r.status === 422) {
        toast(m.dataset.maximo); // a loja recusou o "+": o estoque é menor do que a gaveta sabia
      } else if (!r.ok || r.redirected) {
        throw new Error(`HTTP ${r.status}${r.redirected ? ', redirecionado' : ''}`);
      } else {
        const j = await r.json();
        const ok = aplicar(j && j.sections, foco) || await atualizar(foco);
        dessincronizada = !ok;
        if (ok) { if (nova === 0) saiu.add(chave); anuncia(frase('anuncio')); } else toast(m.dataset.erro); // a loja mudou e a gaveta não leu: avisa e trava
        return;
      }
    } catch (e) {
      aviso('o /cart/change.js não deu certo', e);
      toast(m.dataset.erro);
    } finally { p.limpa(); }
    await acerta(foco); // a sacola de verdade, para a gaveta não mentir
  }
  /* a fila: um trabalho por vez, na ordem. Os cliques e o sincroniza() de fora andam nela */
  function serie(tarefa) {
    ocupado(true);
    const feito = fila.then(tarefa);
    fila = feito.catch((e) => aviso('erro na fila da sacola', e)).then(() => { ocupado(false); if (pendentes === 0) saiu.clear(); });
    return feito.catch(() => false);
  }
  function enfileira(chave, acao) {
    versao += 1;
    serie(async () => { try { return await muda(chave, acao); } finally { versao += 1; } });
  }
  /* o Adicionar do produto (fora da gaveta) entrega as seções da sua resposta e a marca de quando começou: entram na fila, e com a gaveta mexendo (no ar
     agora, ou desde a marca) elas são mais velhas que a sacola e a gaveta relê em vez de aplicar */
  function sincroniza(secoes, marcaDoInicio) {
    const antes = pendentes > 0;
    return serie(async () => {
      const velha = antes || (marcaDoInicio !== undefined && marcaDoInicio !== versao);
      const ok = (!velha && aplicar(secoes)) || await atualizar();
      dessincronizada = !ok;
      if (!ok) toast(frase('erro')); // o produto entrou e a gaveta não leu: avisa, e o próximo clique dela relê primeiro
      return ok;
    });
  }

  document.addEventListener('click', (ev) => {
    const b = ev.target && ev.target.closest ? ev.target.closest('#gaveta [data-acao]') : null;
    if (!b || !gavetaDaSacola()) return;
    ev.preventDefault();
    const m = modelo();
    if (b.getAttribute('aria-disabled') === 'true') { toast(m ? m.dataset.maximo : ''); return; }
    enfileira(b.dataset.chave, b.dataset.acao);
  });

  /* ---------- liga ---------- */
  // na própria página /cart a gaveta não abre: o link da sacola recarrega a página (a sacola inteira está nela)
  if (!NA_PAGINA_CART) G.registrar('sacola', montar);
  // voltar pelo histórico com a página guardada (bfcache): a sacola pode ter mudado em outra aba
  window.addEventListener('pageshow', (ev) => { if (ev.persisted) atualizar(); });

  window.HitSacola = Object.freeze({ aplicar, atualizar, sincroniza, marca, prazo });
})();
